(function () {
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const $  = (sel, ctx = document) => ctx.querySelector(sel);

  function resolveVariant(product, selectedByIndex) {
    return product.variants.find(v => v.options.every((opt, i) => opt == selectedByIndex[i]));
  }

  function initBundleItem(root, form) {
    const product = JSON.parse(root.getAttribute('data-item-json'));

    function readSelected() {
      return $$('.bundle-option-group[data-bundle-option]', root).map(group => {
        const checked = $('input[type="radio"]:checked', group);
        return checked ? checked.value : '';
      });
    }

    function refresh() {
      const selected = readSelected();
      const variant  = resolveVariant(product, selected) || product.variants[0];

      // update hidden variant id for this component
      const vId = $('[data-variant-id]', root);
      if (vId) vId.value = String(variant.id);

      // sync each option value into hidden inputs
      selected.forEach((val, idx) => {
        const h = $(`[data-prop-option="${idx}"]`, root);
        if (h) h.value = val;
      });

      // remove any existing hidden property for this item
      $$(`input[name^="properties[${product.title}"]`, form).forEach(el => el.remove());

      // add combined property input
      const label = selected.filter(Boolean).join(' / ') || 'Standard';
      const input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = `properties[${product.title}]`;
      input.value = label;
      form.appendChild(input);
    }

    // bind change events
    $$('.bundle-option-group input[type="radio"]', root).forEach(r => {
      r.addEventListener('change', refresh);
    });

    // run once
    refresh();
  }

  function init() {
    const form = document.getElementById('bundle-form');
    if (!form) return;

    $$('.bundle [data-bundle-item]').forEach(item => initBundleItem(item, form));

    // Ensure only one id field
    const ids = form.querySelectorAll('input[name="id"]');
    ids.forEach((el, i) => { if (i > 0) el.remove(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
